export const namespace = "touch/";

export const SET_STAGE_POS = "SET_STAGE_POS";
export const SET_MOUSE_POS = "SET_MOUSE_POS";

